import { FC } from 'react';

interface IEditIcon {
  color?: string;
}

export const EditIcon: FC<IEditIcon> = ({ color = '#222222' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 8.33321L15.6666 10.9999M6.66663 17.3332H9.33329L16.3333 10.3332C16.6869 9.97959 16.8856 9.49997 16.8856 8.99988C16.8856 8.49978 16.6869 8.02016 16.3333 7.66654C15.9797 7.31292 15.5001 7.11426 15 7.11426C14.4999 7.11426 14.0202 7.31292 13.6666 7.66654L6.66663 14.6665V17.3332Z"
        stroke={color}
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
